// eslint-disable-next-line no-undef
const isTest = _spPageContextInfo.siteAbsoluteUrl.indexOf("-test") >= 0;

export const configuration = {
  emailServiceUrl: "/_layouts/15/greenpointmail/sendmail.ashx",
  emailTo: "tdc",
  fakeData: false, //window._spPageContextInfo.webAbsoluteUrl.indexOf("localhost") >= 0,
  tenute: {
    query:
      '<View><ViewFields><FieldRef Name="Title"/><FieldRef Name="ContentType"/><FieldRef Name="ID"/><FieldRef Name="Tenuta"/></ViewFields><RowLimit>1</RowLimit><Query><Where><Eq><FieldRef Name="ID" /><Value Type="Number">{0}</Value></Eq></Where></Query></View>'
  },
  rooms: {
    query:
      'Path:{1} ContentTypeId:0x010100C568DB52D9D0A14D9B2FDCC96666E9F2007948130EC3DB064584E219954237AF3900DA042F3A7E1BE848BDCFA4AE46D1096409* RefinableString02:"{0}"',
    properties: [
      "Title",
      "UniqueId",
      "PrezzoOWSCURR",
      "PrezzoMediaOWSCURR",
      "PrezzoAltaOWSCURR",
      "PrezzoAltissimaOWSCURR",
      "OspitiOWSNMBR",
      "Path"
    ]
  },
  experience: {
    query:
      '<View><ViewFields><FieldRef Name="Title"/><FieldRef Name="UniqueId"/><FieldRef Name="DescrizioneBreve"/><FieldRef Name="Durata"/><FieldRef Name="Calici"/><FieldRef Name="Prezzo"/><FieldRef Name="ViniSelezionati"/><FieldRef Name="InizioMattina"/><FieldRef Name="FineMattina"/><FieldRef Name="InizioPomeriggio"/><FieldRef Name="FinePomeriggio"/></ViewFields><RowLimit>1</RowLimit><Query><Where><Eq><FieldRef Name="ID" /><Value Type="Number">{0}</Value></Eq></Where></Query></View>'
  },
  experiences: {
    query:
      'Path:{1} ContentTypeId: 0x010100C568DB52D9D0A14D9B2FDCC96666E9F2007948130EC3DB064584E219954237AF3900DA042F3A7E1BE848BDCFA4AE46D1096406* RefinableString02:"{0}"',
    properties: [
      "Title",
      "UniqueId",
      "DescrizioneBreveOWSTEXT",
      "DurataOWSTEXT",
      "CaliciOWSTEXT",
      "PrezzoOWSCURR",
      "InizioMattinaOWSCHCS",
      "FineMattinaOWSCHCS",
      "InizioPomeriggioOWSCHCS",
      "FinePomeriggioOWSCHCS",
      "RefinableString08",
      "Path",
      "owstaxIdEsperienza"
    ]
  },
  targetsByTenuta: {
    monterufoli: "Monterufoli",
    "fattoria-del-cerro": isTest ? "T1" : "Grazianella",
    "la-poderina": "Poderina",
    colpetrone: "Colpetrone",
    "tenuta-di-montecorona": "Montecorona"
  }
};
